var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "transition",
    { attrs: { name: "fast-fade", mode: "out-in" } },
    [
      !_vm.isHtml
        ? _c(
            "w-card",
            { staticClass: "editor-card", style: { minHeight: "500px" } },
            [
              _c("w-card-title", [
                _vm._v(_vm._s(_vm.$ct("text-editor-title"))),
              ]),
              _c("w-card-content", { staticClass: "editor-content" }, [
                _c("textarea", {
                  ref: "textarea",
                  staticClass: "text-editor",
                  attrs: { disabled: _vm.disabled },
                  domProps: { value: _vm.value },
                  on: {
                    input: function ($event) {
                      return _vm.onTextContentChange($event.target.value)
                    },
                    keyup: function ($event) {
                      return _vm.updateCursorPosition()
                    },
                    mouseup: function ($event) {
                      return _vm.updateCursorPosition()
                    },
                  },
                }),
              ]),
            ],
            1
          )
        : _c(
            "w-card",
            { staticClass: "editor editor-card" },
            [
              _c(
                "w-card-content",
                { staticClass: "message" },
                [
                  _c("vue-editor", {
                    key: _vm.quillKey,
                    staticClass: "html-editor",
                    attrs: {
                      id: "editor",
                      "editor-options": _vm.quillOptions,
                      value: _vm.value,
                      "use-custom-image-handler": "",
                      disabled: _vm.disabled,
                    },
                    on: {
                      input: function ($event) {
                        return _vm.onHtmlContentChange($event)
                      },
                      blur: function ($event) {
                        _vm.focused = false
                      },
                      focus: function ($event) {
                        return _vm.onHtmlEditorFocus($event)
                      },
                      "selection-change": function ($event) {
                        return _vm.updateCursorPosition()
                      },
                      "image-added": _vm.handlerImageAdded,
                    },
                    nativeOn: {
                      mouseup: function ($event) {
                        return _vm.emitHtmlContent()
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }